import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { useRef } from 'react';
import { FaUser } from "react-icons/fa";
import HowPlay from "./HowPlay";
import News from "./News";



function GameioExclusive() {
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const navigate = useNavigate();
    const handlePlayNow = (game) => {
        if (game.link) {
            window.open(game.link, "_self");
        } else {
            navigate("/games");
        }
    };



    const exclusiveGames = [
        {
            id: 1,
            title: "Fire Fighter",
            image: "./assets/gamescard/firefighter.png",
            isLive: true,
            entry: "₦5",
            players: 771,
            playing: 12,
            gameId: 548
        },
        {
            id: 2,
            title: "Sky Race",
            image: "./assets/gamescard/skyrace.png",
            isLive: true,
            entry: "₦5",
            players: 771,
            playing: 12,
            gameId: 548
        },
        {
            id: 3,
            title: "Gameio Road Mash",
            image: "./assets/gamescard/roadmash.png",
            isLive: true,
            entry: "₦5",
            players: 771,
            playing: 12,
            gameId: 548,
            link: "https://thegameio.ng/gameio-roadmash/"
        },

        {
            id: 4,
            title: "Battle Arena",
            image: "./assets/gamescard/battlearena.png",
            isLive: false,
            entry: "₦10",
            players: 892,
            playing: 24,
            gameId: 549
        },
        {
            id: 5,
            title: "Speed Warriors",
            image: "./assets/gamescard/speedwarriors.png",
            isLive: true,
            entry: "₦3",
            players: 654,
            playing: 18,
            gameId: 550
        }
    ];

    return (
        <div
            className="px-4 py-10"
            style={{
                background:
                    "linear-gradient(to bottom, #080618 0%, #181820 20%, #181820 50%, #181820 80%, #080618 100%)",
                paddingBottom: "100px",
            }}
        >
            <div className="max-w-6xl mx-auto">

                {/* HEADER */}
                <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mb-6">
                    <h3 className="text-white uppercase font-semibold text-[20px] sm:text-[24px] md:text-3xl text-center sm:text-left">
                        Gameio Exclusive Game
                    </h3>

                    <div className="flex items-center gap-3">
                        <button
                            ref={prevRef}
                            className="bg-gray-700 btn-hover w-9 h-9 sm:w-10 sm:h-10 rounded-lg flex items-center justify-center"
                        >
                            <span> <IoIosArrowBack size={18} color="#fff" /></span>
                        </button>
                        <button
                            ref={nextRef}
                            className="bg-gray-700 btn-hover w-9 h-9 sm:w-10 sm:h-10 rounded-lg flex items-center justify-center"
                        >
                            <span><IoIosArrowForward size={18} color="#fff" /></span>
                        </button>
                    </div>
                </div>

                {/* SLIDER */}
                <Swiper
                    modules={[Navigation, Autoplay]}
                    loop={true}
                    autoplay={{ delay: 3500, disableOnInteraction: false }}
                    navigation={{
                        prevEl: prevRef.current,
                        nextEl: nextRef.current,
                    }}
                    onBeforeInit={(swiper) => {
                        swiper.params.navigation.prevEl = prevRef.current;
                        swiper.params.navigation.nextEl = nextRef.current;
                    }}
                    spaceBetween={14}
                    breakpoints={{
                        0: {
                            slidesPerView: 2,
                        },
                        640: {
                            slidesPerView: 2,
                        },
                        768: {
                            slidesPerView: 3,
                        },
                        1024: {
                            slidesPerView: 3,
                        },
                    }}
                >
                    {exclusiveGames.map((game) => (
                        <SwiperSlide key={game.id} className="flex justify-center">

                            {/* CARD */}
                            <div
                                className="
                                    bg-[#1A1A22] rounded-xl border border-gray-800
                                    transition-all duration-300
                                    w-[150px]
                                    sm:w-[180px]
                                    md:w-[210px]
                                    lg:w-full
                                "
                            >
                                {/* IMAGE */}
                                <div className="relative">
                                    <img
                                        src={game.image}
                                        alt={game.title}
                                        className="w-full h-[130px] sm:h-[150px] md:h-[170px] object-cover rounded-t-xl"
                                    />

                                    {game.isLive && (
                                        <div className="absolute top-2 right-2 bg-red-600 text-white px-2 py-0.5 rounded text-xs font-bold">
                                            Live
                                        </div>
                                    )}

                                    <div className="absolute -bottom-3 right-0 bg-yellow-500 text-black px-2 py-1 text-xs font-bold clip-badge">
                                        Entry: {game.entry}
                                    </div>
                                </div>

                                {/* CONTENT */}
                                <div className="p-3 sm:p-4">
                                    <h4 className="text-white text-center text-sm sm:text-base font-bold mb-3">
                                        {game.title}
                                    </h4>

                                    <div className="flex justify-between text-[11px] sm:text-xs mb-3 text-gray-400">
                                        <div className="flex items-center gap-1">
                                            <FaUser size={12} />
                                            <span className="text-green-500">{game.players}</span>
                                        </div>
                                        <div className="flex items-center gap-1">
                                            <FaUser size={12} />
                                            <span className="text-green-500">{game.playing}</span>
                                        </div>
                                    </div>

                                    {/* <button className="w-full bg-yellow-500 hover:bg-[#2DCB2A] text-black hover:text-white text-xs sm:text-sm font-bold py-2 rounded transition">
                                        Play Now
                                    </button> */}
                                    <button
                                        className="
    btn-hover
    w-full
    bg-yellow-500
    text-black
    hover:text-white
    text-xs sm:text-sm
    font-bold
    py-3
    px-2
    rounded
    transition
  "
                                        onClick={() => handlePlayNow(game)}
                                    >
                                        <span>Play Now</span>
                                    </button>


                                    <p className="text-center text-[10px] sm:text-xs text-gray-400 mt-2">
                                        Game ID: {game.gameId}
                                    </p>
                                </div>
                            </div>

                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            {/* HOW TO PLAY */}
            <div className="mt-16">
                <HowPlay />
            </div>

            {/* NEWS */}
            <div className="mt-16">
                <News />
            </div>

            <style>{`
                .clip-badge {
                    clip-path: polygon(15% 0%, 100% 0%, 100% 100%, 0% 100%);
                }
  .btn-hover {
    position: relative;
    overflow: hidden;
  }
  .btn-hover::before,
  .btn-hover::after {
    content: "";
    position: absolute;
    left: 0;
    width: 100%;
    height: 50%;
    background: #249f22;
    transform: scaleX(0);
    transition: transform 0.35s ease;
    z-index: 0;
    pointer-events: none;
  }
  .btn-hover::before {
    top: 0;
    transform-origin: left;
  }
  .btn-hover::after {
    bottom: 0;
    transform-origin: right;
  }
  .btn-hover:hover::before,
  .btn-hover:hover::after {
    transform: scaleX(1);
  }
  .btn-hover span {
    position: relative;
    z-index: 1;
  }


            `}</style>
        </div>
    );
}

export default GameioExclusive;
